import Vue from 'vue'
import toastr from '../toastr'
import VueMultiselect from 'vue-multiselect'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import Multiselect from '../../component/dccore-form/NewMultiSelect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import VueMask from 'v-mask'

if ($('#non_default_form').length) {
  Vue.use(VueResource)
  Vue.use(VueMask)

  new Vue({
    el: '#non_default_form',
    components: {
      VueMultiselect,
      Singleselect,
      Multiselect,
      RingLoader,
      Datepicker,
      moment,
      NumberInput
    },
    mixins: [mixins],
    data: {
      loading: 1,
      errors: {},
      day: {
        date: moment().format('YYYY-MM-DD'),
        mealVisibility: '000:00',
        rateVisibility: '000:00',
        delivery: 0,
        brands: [],
        newClient: '000:00',
        regularClient: '000:00',
        paymentTo: '000:00',
        menuChangeTo: '000:00',
        addressChangeTo: '000:00',
        mealResignation: '000:00',
        mealBuy: '000:00',
        earlyDeliveryResignation: '000:00',
        laterDeliveryResignation: '000:00',
        menuRating: '000:00',
        backupOne: '000:00',
        backupTwo: '000:00',
        deliveryChangeDate: '000:00',
        deliveryChangeDateOnThisDay: '000:00',
        planMenuTo: '000:00',
        wmsOverProduction: '000:00',
        resignElementTo: '000:00',
        addSimpleElementTo: '000:00',
        addElementFromWarehouseTo: '000:00',
        addressType: null,
        description: null
      },
      dayId: null,
      selectedBrands: [],
      brands: [],
      addressTypes: []
    },
    mounted () {
      moment.locale('pl')

      this.getBrands()
      this.getType()

      if ($('#day_input_id').length) {
        this.dayId = $('#day_input_id').val()
        this.getNonDefaultDay()
      }

      this.dateChangeEvent()

      this.loading--
    },
    methods: {
      createDay (redirect) {
        let url = Routing.generate('api_post_non_default_day')
        this.errors = {}

        let data = {
          data: Object.assign({}, this.day)
        }

        delete data.data.addressTypeName

        data.data.date = moment(data.data.date).format('YYYY-MM-DD')

        this.loading++
        this.$http.post(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('non_default_day_grid'))
          } else {
            toastr.success(Translator.trans('form.created'))
          }
          this.loading--

        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })

      },
      updateDay (redirect) {
        this.loading++
        this.errors = {}

        let url = Routing.generate('api_patch_non_default_day', { id: this.dayId })

        let data = {
          data: Object.assign({}, this.day)
        }

        delete data.data.addressTypeName
        data.data.date = moment(data.data.date).format('YYYY-MM-DD')

        this.$http.patch(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('non_default_day_grid'))
          } else {
            toastr.success(Translator.trans('form.updated'))
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })

      },
      getNonDefaultDay () {
        this.loading++

        let url = Routing.generate('api_get_non_default_day', { id: this.dayId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          this.selectedBrands = [].concat(response.data.brands)
          this.day = response.data

          this.dateChangeEvent()
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getBrands () {
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      changeTime () {
        this.calculateTime(this.day.newClient, 'newClientDate')
        this.calculateTime(this.day.regularClient, 'regularClientDate')
        this.calculateTime(this.day.paymentTo, 'paymentToDate')
        this.calculateTime(this.day.rateVisibility, 'rateVisibilityDate')
        this.calculateTime(this.day.menuChangeTo, 'menuChangeToDate')
        this.calculateTime(this.day.addressChangeTo, 'addressChangeToDate')
        this.calculateTime(this.day.mealResignation, 'mealResignationDate')
        this.calculateTime(this.day.mealBuy, 'mealBuyDate')
        this.calculateTime(this.day.earlyDeliveryResignation, 'earlyDeliveryResignationDate')
        this.calculateTime(this.day.laterDeliveryResignation, 'laterDeliveryResignationDate')
        this.calculateTime(this.day.menuRating, 'menuRatingDate')
        this.calculateTime(this.day.backupOne, 'backupOneDate')
        this.calculateTime(this.day.backupTwo, 'backupTwoDate')
        this.calculateTime(this.day.deliveryChangeDate, 'deliveryChangeDateDate')
        this.calculateTime(this.day.deliveryChangeDateOnThisDay, 'deliveryChangeDateOnThisDayDate')
        this.calculateTime(this.day.mealVisibility, 'mealVisibilityDate')
        this.calculateTime(this.day.planMenuTo, 'planMenuToDate')
        this.calculateTime(this.day.wmsOverProduction, 'wmsOverProductionDate')
        this.calculateTime(this.day.resignElementTo, 'resignElementToDate')
        this.calculateTime(this.day.addSimpleElementTo, 'addSimpleElementToDate')
        this.calculateTime(this.day.addElementFromWarehouseTo, 'addElementFromWarehouseToDate')
      },
      changeDeliveryDay () {
        this.day.date = moment(this.day.date).format('YYYY-MM-DD')
        let time = this.delivery
        let date = moment.utc(this.day.date).subtract(time, 'days').format('YYYY-MM-DD dddd')

        $('#deliveryDate').html(date)
      },
      calculateTime (time, dateElement) {
        let times = time.split(':')
        let date
        if (['menuRatingDate', 'rateVisibilityDate'].includes(dateElement)) {
          date = moment.utc(this.day.date).add({
            hours: times[0],
            minutes: times[1]
          })
        } else {
          date = moment.utc(this.day.date).subtract({
            hours: times[0],
            minutes: times[1]
          })
        }
        //
        // let date = moment.utc(this.day.date).subtract({
        //   hours: times[0],
        //   minutes: times[1]
        // }).format('YYYY-MM-DD HH:mm dddd')

        $(`#${dateElement}`).html(date.format('YYYY-MM-DD HH:mm dddd'))
      },
      dateChangeEvent () {
        this.changeTime()
        this.changeDeliveryDay()
      },
      getType() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'address_type',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.addressTypes = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      }
    }
  })
}
